import React, { Component } from "react";
import moment from "moment";

import {
  Grid,
  Box,
  Typography,
  IconButton,
  ButtonGroup,
  Button,
} from "@material-ui/core";
import { NavigateNext, NavigateBefore, Clear } from "@material-ui/icons";

import { DateRangePicker } from "react-dates";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import "../../react-dates-custom.css";

class DateFilter extends Component {
  setFocus = (focusedInput) => {
    this.props.setFilter((prev) => ({ ...prev, focusedInput }));
  };

  setDate = (startDate, endDate) => {
    const normalizedEndDate = endDate
      ? moment(endDate).set({
          hour: 23,
          minute: 59,
          second: 59,
        })
      : null;
    this.props.setFilter((prev) => ({
      ...prev,
      startDate,
      endDate: normalizedEndDate,
    }));
  };

  checkDateInput = () => {
    const { dates } = this.props;
    const applied = { ...dates };
    if (applied.startDate && applied.endDate) {
      return;
    }
  };

  clearDate = () => {
    this.props.setFilter((prev) => ({
      ...prev,
      startDate: null,
      endDate: null,
    }));
  };

  setGap = (gap) => {
    const now = moment();
    const yesterday = moment().subtract(1, gap);
    now.set({
      hour: 23,
      minute: 59,
      second: 59,
    });
    this.props.setFilter((prev) => ({
      ...prev,
      startDate: yesterday,
      endDate: now,
      focusedInput: null,
    }));
  };

  render() {
    const { filterName, dates } = this.props;

    return (
      <Box mt={2} mb={2}>
        <Grid container alignItems="center">
          <Grid item>
            <Typography variant="body1" style={{ minHeight: 30 }}>
              {filterName}
            </Typography>
          </Grid>
          {dates.startDate && dates.endDate ? (
            <Grid item>
              <IconButton
                color="primary"
                size="small"
                variant="filled"
                style={{
                  marginBottom: "8px",
                  marginLeft: "8px",
                }}
                onClick={this.clearDate}
              >
                <Clear />
              </IconButton>
            </Grid>
          ) : (
            ""
          )}
        </Grid>
        <Grid spacing={1} container alignItems="flex-end">
          <Grid item>
            <ButtonGroup size="small">
              <Button onClick={() => this.setGap("day")}>
                {filterName == "Last Seen" ? "In 24hr" : "Today"}
              </Button>
              <Button onClick={() => this.setGap("week")}>This Week</Button>
              <Button onClick={() => this.setGap("month")}>This Month</Button>
            </ButtonGroup>
          </Grid>
          <Grid item xs>
            <DateRangePicker
              startDatePlaceholderText="From"
              endDatePlaceholderText="To"
              onClose={() => this.checkDateInput()}
              startDateId={"startDate" + this.props.filterKey}
              endDateId={"endDate" + this.props.filterKey}
              startDate={dates.startDate}
              endDate={dates.endDate}
              onDatesChange={({ startDate, endDate }) =>
                this.setDate(startDate, endDate)
              }
              focusedInput={dates.focusedInput}
              onFocusChange={(focusedInput) => this.setFocus(focusedInput)}
              navPosition="navPositionTop"
              numberOfMonths={1}
              navPrev={
                <NavigationWrapper>
                  <NavigateBefore />
                </NavigationWrapper>
              }
              navNext={
                <NavigationWrapper>
                  <NavigateNext />
                </NavigationWrapper>
              }
              isOutsideRange={(day) => moment().diff(day) < 0}
              hideKeyboardShortcutsPanel
              customArrowIcon={null}
              screenReaderInputMessage={" "}
              small
              readOnly
              minimumNights={0}
            />
          </Grid>
        </Grid>
      </Box>
    );
  }
  // function setToday()
}

// Navigattion icons used in date fliters
function NavigationWrapper(props) {
  return (
    <div>
      <IconButton size="small">{props.children}</IconButton>
    </div>
  );
}

export default DateFilter;
